import React from 'react';
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const GOOGLE_FONTS = [
  'Inter', 'Roboto', 'Open Sans', 'Lato', 'Poppins', 'Montserrat', 
  'Source Sans Pro', 'Nunito', 'Playfair Display', 'Merriweather',
  'Oswald', 'Raleway', 'Ubuntu', 'Fira Sans', 'Work Sans'
];

// Function to load Google Font dynamically
const loadGoogleFont = (fontName: string) => {
  const existingLink = document.querySelector(`link[href*="${fontName.replace(' ', '+')}"]`);
  if (existingLink) return;

  const link = document.createElement('link');
  link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(' ', '+')}:wght@400;500;600;700&display=swap`;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

interface GoogleFontSelectorProps {
  selectedFont: string;
  onFontChange: (font: string) => void;
}

export function GoogleFontSelector({ selectedFont, onFontChange }: GoogleFontSelectorProps) {
  // Load the selected font for preview
  React.useEffect(() => {
    if (selectedFont) {
      loadGoogleFont(selectedFont);
    }
  }, [selectedFont]);

  return (
    <div className="ml-6 space-y-4">
      <div>
        <Label htmlFor="font-select">Select Font</Label>
        <Select 
          value={selectedFont} 
          onValueChange={(value) => {
            console.log('🔤 [GoogleFontSelector] Font selection changed from', selectedFont, 'to', value);
            onFontChange(value);
          }}
        >
          <SelectTrigger id="font-select">
            <SelectValue placeholder="Choose a font" />
          </SelectTrigger>
           <SelectContent className="bg-white">
             {GOOGLE_FONTS.map((font) => (
               <SelectItem key={font} value={font}>
                 <span style={{ fontFamily: font }}>{font}</span>
               </SelectItem>
             ))}
           </SelectContent>
        </Select>
      </div>
      
      <div className="p-4 border rounded-lg">
        <Label className="text-sm text-muted-foreground">Preview</Label>
        <div style={{ fontFamily: selectedFont }} className="mt-2">
          <p className="text-lg font-bold">The quick brown fox jumps over the lazy dog</p>
          <p className="text-sm">ABCDEFGHIJKLMNOPQRSTUVWXYZ</p>
          <p className="text-sm">abcdefghijklmnopqrstuvwxyz</p>
          <p className="text-sm">1234567890</p>
        </div>
      </div>
    </div>
  );
}